import gql from 'graphql-tag';

export default gql`
  query ordersOrFulfillmentNotes($filter: OrderOrFulfillmentNoteFilterInput, $pagination: Pagination!) {
    ordersOrFulfillmentNotes(pagination: $pagination, filter: $filter) {
      totalPage
      totalResults
      data {
        ... on Order {
          id
          total
          totalItemPrice
          grossTotal
          orderDate
          status
          statusText
          paymentMethod
          note
          declineReason
          approvedAt
          redelivery
          discount
          store {
            id
          }
          deliveryTime {
            start
            end
          }
          items {
            total
            orderedQuantity
            deliveryQuantity
            note
            buyerNote
            deliveredNote
            price
            quantity
            orderedGrossPrice
            grossTotal
            previousQuantity
            grossPrice
            deliveredQuantity
            orderedPrice
            priceV2 {
              price
              originalPrice
              vat
              vatIncluded
            }
            product {
              id
              name
              imageUrl
              imageFilePath
            }
          }
        }
        ... on FulfillmentNote {
          fulfillmentNoteId
          fulfillmentNoteShortCode
          deliveryStartDateTime
          deliveryEndDateTime
          orderDateTime
          paymentMethod
          total
          discount
          itemCount
          fulfillmentNoteStatus
          orderIds
          orders {
            id
            total
            totalItemPrice
            grossTotal
            orderDate
            status
            statusText
            paymentMethod
            note
            declineReason
            approvedAt
            redelivery
            discount
            store {
              id
            }
            items {
              product {
                id
                name
                supplierInternalCode
                imageUrl
                imageFilePath
              }
            }
          }
          feedback {
            id
            objectType
            objectId
            submittedByUserId
            rating
            tags
            comment
            dismissedAt
            submittedAt
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;
